/**
 * Permission result kinds that represent a denial.
 * Approved/auto-resolved permissions render nothing in the timeline.
 * Matches the runtime's permission result enum.
 */
export const DENIED_RESULT_KINDS = new Set([
  'denied-by-rules',
  'denied-interactively-by-user',
  'denied-no-approval-rule-and-could-not-request-from-user',
  'denied-by-content-exclusion-policy',
  'aborted-by-user',
])

/** Returns true when the result kind represents a denied permission. */
export function isDeniedResult(kind: string | undefined): boolean {
  if (!kind) return false
  return DENIED_RESULT_KINDS.has(kind)
}
